module.exports = __webpack_public_path__ + "img/a19.850de42c.jpg";